import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import MasterBase from "../components/MasterLayout";
import RawSupplyInEntry from "./components/RawSupplyInEntry";
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { styled } from '@material-ui/core/styles';
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc';
import { isEmpty, getformid, getcontroller, getsubkey, getWindowDimensions, initializedata } from '../modules/appLibrary';
import { changestatus, entryformlock, listtabs, listoption, setgridlist } from '../modules/formstore';
import { setentrypanel } from '../modules/toolpanelstore';

const DB_MATERIAL_TYPES = {
    "1": "0",
    "2": "1",
    "3": "2",
};
const DETAIL_TYPE_BY_MATERIAL_TYPE = {
    "0": "110",
    "1": "120",
    "2": "130",
};

function toRawSupplyDisplayData(data) {
    const displayData = { ...(data || {}) };
    if (String(displayData.ZSK_SOKOKBN ?? "").trim() === "2") {
        displayData.ZSK_SOKOCD = String(displayData.ZSK_SOKOSUBCD ?? "").trim();
    }
    return displayData;
}
const COMMON_ENTRY_PANEL_TYPES = ["103", "100", "101", "102", "104"];
const PanelSelectorItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none',
}));

function canEditExistingSlip(entryData) {
    const akaKuro = String(entryData?.ZSK_AKAKUROKBN ?? "").trim();
    const teisei = String(entryData?.ZSK_TEISEIKBN ?? "").trim();
    const kikan = String(entryData?.ZSK_KIKANCP_FLG ?? "").trim();

    if (akaKuro !== "1"
        || teisei !== "1"
        || (kikan !== "0" && kikan !== "1")) return false;

    if (kikan !== "0") return true;

    const originalSlipNo = String(entryData?.ZSK_MOTODENNO ?? "").trim();
    const previousSlipNo = String(entryData?.ZSK_MAEDENNO ?? "").trim();
    return originalSlipNo === "" && previousSlipNo === "";
}

export const RawSupplyIn = props => {

    const panelsdef = [];
    const formid = getformid("RawSupplyIn", props.location.search);
    const controller = getcontroller("RawSupplyIn", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const accctl = useSelector(state => state.user.accctl);
    const formstatus = useSelector(state => state.form.status);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const fnc = useRef();
    const masterRef = useRef();
    const entryRef = useRef();
    const [panels, setPanels] = useState([]);
    const [columnInfo, setColumnInfo] = useState([]);
    const [columns, setColumns] = useState([]);
    const [layoutReadySearch, setLayoutReadySearch] = useState(null);
    const [materialType, setMaterialType] = useState("0");
    const [entryResetKey, setEntryResetKey] = useState(0);
    const [entryDetailResetKey, setEntryDetailResetKey] = useState(0);
    const [entryDetail, setEntryDetail] = useState({});
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const rawPurchaseReferenceRequestRef = useRef(0);
    const rawSupplyReferenceRequestRef = useRef(0);
    const locationSaveRequestRef = useRef(0);
    const rawPurchaseReferenceMaterialTypeRef = useRef("0");
    const layoutReadyRef = useRef(false);
    const layoutReadySearchRef = useRef(null);
    const layoutRequestRef = useRef(0);
    const pendingShowRef = useRef(null);

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const layoutReady = layoutReadySearch === search;
    const ComFunc = React.forwardRef(ComFunction);


    const actionurl = {
        "update": "Forms/Update",
        "getlist": "RawSupplyIn/GetListData",
        "saveas": "Forms/SaveAs",
    }

    const navmenu = buildNavmenu(entrydataRef.current);

    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
    ];

    function buildNavmenu(entryData) {
        const nextNavmenu = [
            { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
            { status: "VIEW", menuid: "print1", icon: "print", label: "原材料支給伝票発行" },
            { status: "ENTRY FORM", menuid: "print1", icon: "print", label: "原材料支給伝票発行" },
        ];
        const reqFlg = String(entryData?.ZSK_REQFLG ?? "").trim();
        const synFlg1 = String(entryData?.ZSK_SYNFLG1 ?? "").trim();
        if (reqFlg === "1" && (synFlg1 === "0" || synFlg1 === "1" || synFlg1 === "2")) {
            nextNavmenu.push({
                status: "ENTRY FORM",
                menuid: "withdraw",
                icon: "cancel",
                label: "申請解除"
            });
        }
        return nextNavmenu;
    }

    function refreshNavmenu(entryData) {
        if (typeof masterRef.current?.ChangeNavmenu !== "function") return;
        masterRef.current.ChangeNavmenu(buildNavmenu(entryData));
    }

    function toolbarPanels() {
        const detailType = DETAIL_TYPE_BY_MATERIAL_TYPE[materialType];
        return panels.filter(panel =>
            (COMMON_ENTRY_PANEL_TYPES.includes(panel.type) || panel.type === detailType)
            && !panel.hide
        );
    }

    function sortToolbarPanels({ oldIndex, newIndex }) {
        const visiblePanels = toolbarPanels();
        if (oldIndex === newIndex
            || visiblePanels[oldIndex] === undefined
            || visiblePanels[newIndex] === undefined) return;
        const reordered = arrayMove(visiblePanels, oldIndex, newIndex);
        let visibleIndex = 0;
        setPanels(panels.map(panel => visiblePanels.some(item =>
            item.id === panel.id && item.type === panel.type)
            ? reordered[visibleIndex++]
            : panel));
    }

    const SortablePanelItem = SortableElement(({ panel }) => (
        <PanelSelectorItem className="minwidth0">
            <Chip
                label={panel.abbr}
                title={panel.name}
                size="small"
                onClick={() => entryRef.current?.jumpPanel(panel)}
            />
        </PanelSelectorItem>
    ));

    const SortablePanelSelector = SortableContainer(({ items, layoutLock }) => (
        <ul style={{ display: 'flex' }}>
            {items.map((panel, index) => (
                <SortablePanelItem
                    key={panel.id + "_" + panel.type}
                    index={index}
                    panel={panel}
                    disabled={layoutLock}
                />
            ))}
        </ul>
    ));

    function show(data, pushcode, option) {
        if (!layoutReadyRef.current || layoutReadySearchRef.current !== search) {
            pendingShowRef.current = { data, pushcode, option, search };
            return true;
        }
        return executeShow(data, pushcode, option);
    }

    function executeShow(data, pushcode, option) {
        ++rawPurchaseReferenceRequestRef.current;
        ++rawSupplyReferenceRequestRef.current;
        const optionMaterialType = option === null || option === undefined
            ? ""
            : String(option);
        const dataMaterialType = data === null || data === undefined
            ? ""
            : String(data.ZSK_ZAIRYOKBN);
        const selectedMaterialType = ["0", "1", "2"].includes(optionMaterialType)
            ? optionMaterialType
            : DB_MATERIAL_TYPES[dataMaterialType] || "0";

        rawPurchaseReferenceMaterialTypeRef.current = selectedMaterialType;
        setMaterialType(selectedMaterialType);
        const isNewForm = data === null
            || (data === undefined && isEmpty(entrydataRef.current?.ZSK_DENNO));
        if (!isNewForm) {
            const entryCodeValue = data === undefined || data === null
                ? entrydataRef.current?.ZSK_DENNO
                : data.ZSK_DENNO;
            const entryCode = entryCodeValue === null || entryCodeValue === undefined
                ? ""
                : String(entryCodeValue).trim();
            if (isEmpty(entryCode)) {
                entrydataRef.current = null;
                setEntryDetail({});
                setEntryResetKey(current => current + 1);
                fnc.current.warnmsg("支給番号を取得できません。");
                dispatch(changestatus("VIEW"));
                return false;
            }

            entrydataRef.current = {
                ZSK_ZAIRYOKBN: selectedMaterialType
            };
            setEntryDetail({});
            setEntryResetKey(current => current + 1);

            fnc.current.postaxios("RawSupplyIn/GetData",
                {
                    code: entryCode,
                    colinfo: columnInfo,
                    controller: controller
                },
                {
                    onSuccess: function (result) {
                        fnc.current.margeMaster(result.master);
                        entrydataRef.current = {
                            ...toRawSupplyDisplayData(result.data),
                            ZSK_ZAIRYOKBN: selectedMaterialType
                        };
                        dispatch(entryformlock(!canEditExistingSlip(entrydataRef.current)));
                        refreshNavmenu(entrydataRef.current);
                        setEntryDetail(result.detail || {});
                        setEntryResetKey(current => current + 1);
                        fnc.current.entryrerender();
                        fnc.current.modify(false);
                        fnc.current.wait(false);
                    },
                    onError: function (result) {
                        const message = isEmpty(result?.errDescription)
                            ? "ENTRY FORMのデータを取得できません。"
                            : result.errDescription;
                        fnc.current.warnmsg(message);
                        fnc.current.wait(false);
                        dispatch(changestatus("VIEW"));
                    }
                }
            );
            return true;
        }

        const newFormData = {
            ZSK_TEISEIKBN: "1",
            ZSK_DENNO: "",
            ZSKM_DENNO: "",
            ZSK_ZAIRYOKBN: selectedMaterialType,
            ZSK_MOTODENNO: "",
            ZSK_AKAKUROKBN: "1",
            ZSK_SIKYUBI: "",
            ZSK_KEIJYODATE: "",
            ZSK_DENSYUBETU: "",
            ZSKM_DENSYUBETU: "",
            ZSK_SANMOTODENKBN: "",
            ZSK_SANMOTODENNO: "",
            ZSK_KAIGAIKBN: "",
            ZSK_REQFLG: "",
            ZSK_KIKANCP_FLG: "",
            ZSK_CREATEAC: "",
            ZSK_CREATEDATE: "",
            ZSK_UPDATEAC: "",
            ZSK_UPDATE: ""
        };
        entrydataRef.current = newFormData;
        setEntryDetail({});
        setEntryResetKey(current => current + 1);

        fnc.current.postaxios("common/GetInitSqlValue", { colinfo: columnInfo },
            {
                onSuccess: function (data) {
                    const initialColumnInfo = columnInfo.map(col =>
                        Object.prototype.hasOwnProperty.call(data.returnData, col.columnid)
                            ? { ...col, initvalue: data.returnData[col.columnid] }
                            : col
                    );
                    const commonInitialData = initializedata(initialColumnInfo, accctl) || {};
                    fnc.current.postaxios("RawSupplyIn/GetData", { code: "" },
                        {
                            onSuccess: function (result) {
                                entrydataRef.current = {
                                    ...newFormData,
                                    ...commonInitialData,
                                    ...(result.data || {}),
                                    ZSK_ZAIRYOKBN: selectedMaterialType,
                                    ZSK_KEIJYODATE: ""
                                };
                                refreshNavmenu(entrydataRef.current);
                                fnc.current.entryrerender();
                                fnc.current.modify(false);
                                fnc.current.wait(false);
                            },
                            onError: function (result) {
                                const message = isEmpty(result?.errDescription)
                                    ? "NEW FORMの初期値を取得できません。"
                                    : result.errDescription;
                                fnc.current.warnmsg(message);
                                fnc.current.wait(false);
                                dispatch(changestatus("VIEW"));
                            }
                        }
                    );
                },
                onError: function (result) {
                    const message = isEmpty(result?.errDescription)
                        ? "NEW FORMの初期値を取得できません。"
                        : result.errDescription;
                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                    dispatch(changestatus("VIEW"));
                }
            }, true
        );
        return true;
    }

    function PrintSelectedSlips() {
        const selectedRows = masterRef.current?.GetSelectrowdata() ?? [];
        if (selectedRows.length === 0) {
            fnc.current.warnmsg("対象データを選択してください。");
            return;
        }

        const denNoList = [
            ...new Set(
                selectedRows
                    .map(row => String(row.ZSK_DENNO ?? "").trim())
                    .filter(value => value !== "")
            )
        ];
        if (denNoList.length === 0) {
            fnc.current.warnmsg("伝票番号が取得できません。");
            return;
        }

        fnc.current.postaxios(
            "GenzairyoSikyuReport/Generate",
            { denNoList },
            {
                onSuccess: function (data) {
                    const params = {
                        excelfile: data.returnData.filename,
                        dnfile: data.returnData.dnfile
                    };
                    fnc.current.filedownload("excel/ExcelDownload", params);
                    fnc.current.wait(false);
                },
                errmsg: "印刷が失敗しました。"
            }
        );
    }

    function PrintCurrentSlip() {
        const denNo = String(entrydataRef.current?.ZSK_DENNO ?? "").trim();
        if (!/^[0-9]{8}$/.test(denNo)) {
            fnc.current.warnmsg("支給番号が取得できません。");
            return;
        }

        fnc.current.postaxios(
            "GenzairyoSikyuReport/Generate",
            { denNo },
            {
                onSuccess: function (data) {
                    const params = {
                        excelfile: data.returnData.filename,
                        dnfile: data.returnData.dnfile
                    };
                    fnc.current.filedownload("excel/ExcelDownload", params);
                    fnc.current.wait(false);
                },
                errmsg: "印刷が失敗しました。"
            }
        );
    }

    function executeApplicationCancel(denNo, getList, noconfirm = false) {
        fnc.current.postaxios(
            "RawSupplyIn/AppCancel",
            {
                type: "0",
                controller: formid,
                code: denNo,
                rowdata: [{ rowid: denNo }],
                noconfirm: noconfirm,
            },
            {
                onSuccess: function (data) {
                    const warnings = Array.isArray(data.warning) ? data.warning : [];
                    if (warnings.length === 0) {
                        fnc.current.success();
                        if (typeof getList === "function") getList(false);
                        if (show(undefined, null, materialType) === false) {
                            fnc.current.wait(false);
                        }
                        return;
                    }

                    if (data.confirm === true) {
                        fnc.current.confmsg(
                            warnings.map(item => item.message),
                            () => executeApplicationCancel(denNo, getList, true)
                        );
                    } else {
                        fnc.current.showwarndescription(
                            "申請解除できませんでした。",
                            warnings
                        );
                    }
                    fnc.current.wait(false);
                },
                errmsg: "申請解除に失敗しました"
            }
        );
    }

    function withdrawApplication(getList) {
        if (formstatus !== "ENTRY FORM") return;
        const entryData = entrydataRef.current || {};
        const reqFlg = String(entryData.ZSK_REQFLG ?? "").trim();
        if (reqFlg !== "1") {
            fnc.current.warnmsg("このデータは申請されていません。");
            return;
        }

        const synFlg1 = String(entryData.ZSK_SYNFLG1 ?? "").trim();
        if (synFlg1 === "2") {
            fnc.current.warnmsg("承認済のデータは変更不可です。");
            return;
        }
        if (synFlg1 === "3") {
            fnc.current.warnmsg("却下のデータは変更不可です。");
            return;
        }
        if (synFlg1 !== "0" && synFlg1 !== "1") {
            fnc.current.warnmsg("申請解除できる承認状態ではありません。");
            return;
        }

        const denNo = String(entryData.ZSK_DENNO ?? "").trim();
        if (!/^[0-9]{8}$/.test(denNo)) {
            fnc.current.warnmsg("申請解除対象の支給番号が不正です。");
            return;
        }
        fnc.current.confmsg("申請解除します。宜しいでしょうか？", () => {
            executeApplicationCancel(denNo, getList);
        });
    }

    function entryAction(action, finallycallback, getList) {
        if (formstatus === "VIEW" && action === "print1") {
            PrintSelectedSlips();
        }
        if (formstatus === "ENTRY FORM" && action === "print1") {
            PrintCurrentSlip();
            return;
        }
        if (action === "withdraw") {
            withdrawApplication(getList);
            return;
        }
        if (action === "delete") {
            deleteEntry(finallycallback);
            return;
        }
        if (action !== "save") return;

        const entryData = entrydataRef.current || {};
        const referenceType = String(entryData.ZSK_SANMOTODENKBN ?? "").trim();
        const referenceNo = String(entryData.ZSK_SANMOTODENNO ?? "").trim();
        const documentType = String(entryData.ZSK_DENSYUBETU ?? "").trim();
        const ptRequiredInputInvalid =
            (referenceType !== "" && referenceNo === "")
            || (documentType === "02" && referenceType === "");
        const isInsertForm = formstatus === "NEW FORM" || formstatus === "COPY FORM";
        const dZskSaveSupported = isInsertForm || formstatus === "ENTRY FORM";
        const materialPurchaseIssueSupported =
            dZskSaveSupported
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && (String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
                || String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2")
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2";
        const materialPurchaseDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const materialPurchaseOverseasPaidSupported =
            isInsertForm
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() !== ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryPurchaseIssueSupported =
            dZskSaveSupported
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && (String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
                || String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2")
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryPurchaseDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryPurchaseOverseasPaidSupported =
            isInsertForm
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() !== ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialPurchaseIssueSupported =
            dZskSaveSupported
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && (String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
                || String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2")
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialPurchaseDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialPurchaseOverseasPaidSupported =
            isInsertForm
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() !== ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const materialRawSalesReturnOverseasPaidSupported =
            isInsertForm
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "3"
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() !== ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryRawSalesReturnOverseasPaidSupported =
            isInsertForm
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "3"
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() !== ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialRawSalesReturnOverseasPaidSupported =
            isInsertForm
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "3"
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() !== ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const materialReturnSupported =
            dZskSaveSupported
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "2"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && (String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
                || String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2")
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2";
        const materialReturnDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "2"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryReturnSupported =
            dZskSaveSupported
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "2"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && (String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
                || String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2")
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryReturnDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "2"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialReturnSupported =
            dZskSaveSupported
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "2"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && (String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
                || String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2")
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialReturnDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === "2"
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "02"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryNoReferenceOverseasFreeSupported =
            dZskSaveSupported
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryNoReferenceDomesticFreeSupported =
            dZskSaveSupported
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryNoReferenceDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const accessoryNoReferenceOverseasPaidSupported =
            isInsertForm
            && materialType === "1"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const materialNoReferenceOverseasFreeSupported =
            dZskSaveSupported
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const materialNoReferenceDomesticFreeSupported =
            dZskSaveSupported
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const materialNoReferenceDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const materialNoReferenceOverseasPaidSupported =
            isInsertForm
            && materialType === "0"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "0"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialNoReferenceOverseasFreeSupported =
            dZskSaveSupported
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialNoReferenceDomesticFreeSupported =
            dZskSaveSupported
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "2"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialNoReferenceDomesticPaidSupported =
            dZskSaveSupported
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "1"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const submaterialNoReferenceOverseasPaidSupported =
            isInsertForm
            && materialType === "2"
            && String(entryData.ZSK_ZAIRYOKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SANMOTODENKBN ?? "").trim() === ""
            && String(entryData.ZSK_SANMOTODENNO ?? "").trim() === ""
            && String(entryData.ZSK_DENSYUBETU ?? "").trim() === "01"
            && String(entryData.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(entryData.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(entryData.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(entryData.ZSK_TEISEIKBN ?? "").trim() === "1";
        const supported = materialPurchaseIssueSupported
            || materialPurchaseDomesticPaidSupported
            || materialPurchaseOverseasPaidSupported
            || accessoryPurchaseIssueSupported
            || accessoryPurchaseDomesticPaidSupported
            || accessoryPurchaseOverseasPaidSupported
            || submaterialPurchaseIssueSupported
            || submaterialPurchaseDomesticPaidSupported
            || submaterialPurchaseOverseasPaidSupported
            || materialRawSalesReturnOverseasPaidSupported
            || accessoryRawSalesReturnOverseasPaidSupported
            || submaterialRawSalesReturnOverseasPaidSupported
            || materialReturnSupported
            || materialReturnDomesticPaidSupported
            || accessoryReturnSupported
            || accessoryReturnDomesticPaidSupported
            || submaterialReturnSupported
            || submaterialReturnDomesticPaidSupported
            || accessoryNoReferenceOverseasFreeSupported
            || accessoryNoReferenceDomesticFreeSupported
            || accessoryNoReferenceDomesticPaidSupported
            || accessoryNoReferenceOverseasPaidSupported
            || materialNoReferenceOverseasFreeSupported
            || materialNoReferenceDomesticFreeSupported
            || materialNoReferenceDomesticPaidSupported
            || materialNoReferenceOverseasPaidSupported
            || submaterialNoReferenceOverseasFreeSupported
            || submaterialNoReferenceDomesticFreeSupported
            || submaterialNoReferenceDomesticPaidSupported
            || submaterialNoReferenceOverseasPaidSupported;
        if (!supported && !ptRequiredInputInvalid) {
            fnc.current.warnmsg(
                "この登録経路は未対応です。国内・無償の対応済み経路、素材・附属・副資材の原材料仕入参照・国内／海外有償NEW FORM、原材料支給参照・国内有償返品NEW FORM、原材料売上参照・海外有償返品NEW FORM、または参照元なし・国内／海外無償・国内／海外有償NEW FORMだけ登録できます。"
            );
            return;
        }
        if (entryRef.current === null
            || entryRef.current === undefined
            || typeof entryRef.current.getCurrentDetailRows !== "function") {
            fnc.current.warnmsg("原材料明細を取得できません。");
            return;
        }

        const detailType = DETAIL_TYPE_BY_MATERIAL_TYPE[materialType];
        if (detailType === undefined) {
            fnc.current.warnmsg("材料区分に対応する明細区分を取得できません。");
            return;
        }

        const detailRows = entryRef.current.getCurrentDetailRows(detailType);
        if (detailRows.length === 0 && !ptRequiredInputInvalid) {
            fnc.current.warnmsg("登録すべき明細が存在しません。");
            return;
        }

        const paramdata = createSavePayload(entryData, detailType, detailRows);
        insertEntryWithResolvedLocation(paramdata, getList);
    }

    function insertEntryWithResolvedLocation(paramdata, getList) {
        const requestHeader = paramdata.data || {};
        const sokoKbn = String(requestHeader.ZSK_SOKOKBN ?? "").trim();
        const displayCode = String(requestHeader.ZSK_SOKOCD ?? "").trim();
        const requestNo = ++locationSaveRequestRef.current;
        if (sokoKbn !== "2") {
            const saveData = { ...requestHeader, ZSK_SOKOSUBCD: "00000" };
            insertEntry({ ...paramdata, data: saveData }, getList);
            return;
        }

        fnc.current.postaxios(
            "RawSupplyIn/ValidateLocation",
            {
                data: {
                    sokoKbn,
                    displayCode,
                    supplySourceCode: String(requestHeader.ZSK_SIKYUMOTOCD ?? "").trim(),
                    brandCode: String(requestHeader.ZSK_BRDCD ?? "").trim(),
                    supplyDate: String(requestHeader.ZSK_SIKYUBI ?? "").trim(),
                    accountingDate: String(requestHeader.ZSK_KEIJYODATE ?? "").trim(),
                },
            },
            {
                onSuccess: function (data) {
                    if (requestNo !== locationSaveRequestRef.current) return;
                    const currentHeader = entrydataRef.current || {};
                    if (String(currentHeader.ZSK_SOKOKBN ?? "").trim() !== sokoKbn
                        || String(currentHeader.ZSK_SOKOCD ?? "").trim() !== displayCode) {
                        fnc.current.wait(false);
                        return;
                    }
                    const resolved = data?.data || {};
                    const locationCode = String(resolved.TOR_CODE ?? "").trim();
                    const locationSubCode = String(resolved.TOR_SUBCODE ?? "").trim();
                    if (resolved.valid !== true
                        || locationCode === ""
                        || locationSubCode === "") {
                        fnc.current.wait(false);
                        fnc.current.warnmsg("在庫場所が現在の条件で有効ではありません。");
                        return;
                    }

                    insertEntry({
                        ...paramdata,
                        data: {
                            ...requestHeader,
                            ZSK_SOKOCD: locationCode,
                            ZSK_SOKOSUBCD: locationSubCode,
                        },
                    }, getList);
                },
                onError: function (data) {
                    if (requestNo !== locationSaveRequestRef.current) return;
                    fnc.current.wait(false);
                    fnc.current.warnmsg(
                        String(data?.errDescription ?? "").trim()
                        || "在庫場所の有効性を確認できません。"
                    );
                },
            }
        );
    }

    function deleteEntry(finallycallback, noconfirm = false) {
        if (formstatus !== "ENTRY FORM") {
            fnc.current.warnmsg("新規入力中のデータは削除できません。");
            return;
        }

        const entryData = entrydataRef.current || {};
        const denNo = String(entryData.ZSK_DENNO ?? "").trim();
        if (denNo === "") {
            fnc.current.warnmsg("削除対象の支給番号を取得できません。");
            return;
        }
        const requestData = {
            type: "0",
            controller: formid,
            code: denNo,
            data: { ...entryData },
            rowdata: [{ rowid: denNo }],
            colinfo: [...columnInfo],
            tabletype: "0",
            noconfirm: noconfirm,
        };
        fnc.current.postaxios("RawSupplyIn/Delete", requestData,
            {
                onSuccess: function (data) {
                    const warnings = Array.isArray(data.warning) ? data.warning : [];
                    if (warnings.length === 0) {
                        if (typeof finallycallback === "function") {
                            finallycallback(denNo, ["ZSK_DENNO"]);
                        }
                        fnc.current.success();
                        fnc.current.wait(false);
                        return;
                    }

                    if (data.confirm === true) {
                        const messages = [
                            "内容を確認しそのまま削除する場合はOK、削除しない場合はCancelを選択してください。",
                            "　",
                            ...warnings.map(item => "・" + item.message),
                        ];
                        fnc.current.confmsg(
                            messages,
                            () => deleteEntry(finallycallback, true)
                        );
                    } else {
                        fnc.current.showwarndescription(
                            warnings.length + "件の制約違反により削除できませんでした。",
                            warnings
                        );
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        );
    }

    function createSavePayload(entryData, detailType, detailRows) {
        const entryCode = formstatus === "ENTRY FORM"
            ? String(entryData.ZSK_DENNO ?? "").trim()
            : "";
        const savePanelTypes = [
            ...COMMON_ENTRY_PANEL_TYPES,
            detailType,
            String(Number(detailType) + 1),
        ];
        const saveDetailRows = formstatus === "COPY FORM"
            ? detailRows.map(row => ({
                ...row,
                ZSKM_DENNO: "",
                ZSKM_AKAKUROKBN: "1",
                ZSKM_INVALID: 0,
                ZSKM_DELDATETIME: "",
                ZSKM_INPCID: "",
                ZSKM_CREATEAC: "",
                ZSKM_CREATEDATE: "",
                ZSKM_UPPCID: "",
                ZSKM_UPDATEAC: "",
                ZSKM_UPDATE: "",
            }))
            : detailRows;
        const saveColumnInfo = columnInfo.filter(column =>
            savePanelTypes.includes(String(column.type ?? ""))
        ).map(column => {
            if (column.columnid === "ZSK_SANMOTODENKBN") {
                const options = Array.isArray(column.options) ? column.options : [];
                const hasRawSalesReference = options.some(option =>
                    String(option?.code ?? "").trim() === "3"
                );
                if (hasRawSalesReference) return column;

                return {
                    ...column,
                    options: [
                        ...options,
                        {
                            code: "3",
                            name: "原材料売上（海外有償支給）",
                        },
                    ],
                };
            }
            if (column.columnid === "ZSK_SHANAIRATE" && column.decimalplace !== 2) {
                return { ...column, decimalplace: 2 };
            }
            if (column.columnid === "ZSK_SIKYUMOTOCD" && column.dataid !== "") {
                return { ...column, dataid: "" };
            }
            return column;
        });
        return {
            type: "0",
            layout_type: masterRef.current.ListType(),
            controller: formid,
            data: { ...entryData },
            detail: {
                [detailType]: saveDetailRows.map(row => ({ ...row })),
            },
            colinfo: saveColumnInfo,
            code: entryCode,
            noconfirm: false,
            images: [],
            files: [],
        };
    }

    function insertEntry(paramdata, getList, noconfirm = false) {
        const detail = Object.entries(paramdata.detail || {}).reduce(
            (result, [detailType, rows]) => {
                result[detailType] = Array.isArray(rows)
                    ? rows.map(row => ({ ...row }))
                    : [];
                return result;
            },
            {}
        );
        const requestData = {
            ...paramdata,
            data: { ...paramdata.data },
            detail: detail,
            colinfo: [...paramdata.colinfo],
            noconfirm: noconfirm,
        };
        const requestHeader = requestData.data || {};
        const requestMaterialType = String(requestHeader.ZSK_ZAIRYOKBN ?? "").trim();
        const isInsertForm = formstatus === "NEW FORM" || formstatus === "COPY FORM";
        const overseasPaidSalesIssue =
            isInsertForm
            && ["0", "1", "2"].includes(requestMaterialType)
            && ((((String(requestHeader.ZSK_SANMOTODENKBN ?? "").trim() === ""
                        && String(requestHeader.ZSK_SANMOTODENNO ?? "").trim() === "")
                    || (String(requestHeader.ZSK_SANMOTODENKBN ?? "").trim() === "1"
                        && String(requestHeader.ZSK_SANMOTODENNO ?? "").trim() !== ""))
                    && String(requestHeader.ZSK_DENSYUBETU ?? "").trim() === "01")
                || (String(requestHeader.ZSK_SANMOTODENKBN ?? "").trim() === "3"
                    && String(requestHeader.ZSK_SANMOTODENNO ?? "").trim() !== ""
                    && String(requestHeader.ZSK_DENSYUBETU ?? "").trim() === "02"))
            && String(requestHeader.ZSK_KAIGAIKBN ?? "").trim() === "2"
            && String(requestHeader.ZSK_SIKYUKBN ?? "").trim() === "1"
            && String(requestHeader.ZSK_AKAKUROKBN ?? "").trim() === "1"
            && String(requestHeader.ZSK_TEISEIKBN ?? "").trim() === "1";
        const saveApi = formstatus === "ENTRY FORM"
            ? "RawSupplyIn/UpdateEntry"
            : "RawSupplyIn/InsertEntry";
        fnc.current.postaxios(saveApi, requestData,
            {
                onSuccess: function (data) {
                    const warnings = Array.isArray(data.warning) ? data.warning : [];
                    if (warnings.length === 0) {
                        const entryCode = String(data.request ?? "").trim();
                        if (entryCode === "") {
                            fnc.current.warnmsg(overseasPaidSalesIssue
                                ? "登録後の材料売上番号を取得できません。"
                                : "登録後の支給番号を取得できません。");
                            fnc.current.wait(false);
                            return;
                        }

                        if (overseasPaidSalesIssue) {
                            dispatch(changestatus("ENTRY FORM"));
                            fnc.current.modify(false);
                            fnc.current.success();
                            if (typeof getList === "function") getList(false);
                            fnc.current.infomsg(
                                "以下のデータは仕入先が海外で有償支給のため、仕入先売上で登録されました。\n"
                                + "原材料売上入力画面にて確認が可能です。\n"
                                + `伝票番号[${entryCode}]`
                            );
                            return;
                        }

                        entrydataRef.current = {
                            ...(entrydataRef.current || {}),
                            ZSK_DENNO: entryCode,
                        };
                        dispatch(changestatus("ENTRY FORM"));
                        fnc.current.modify(false);
                        fnc.current.success();
                        show(undefined, undefined, requestMaterialType);
                        return;
                    }

                    if (data.confirm === true) {
                        const messages = [
                            "内容を確認しそのまま登録する場合はOK、修正する場合はCancelを選択してください。",
                            "　",
                            ...warnings.map(item => "・" + item.message),
                        ];
                        fnc.current.confmsg(
                            messages,
                            () => insertEntry(paramdata, getList, true)
                        );
                    } else {
                        const message = warnings.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(message, warnings);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        );
    }

    function resetReferenceSourceDetail() {
        setEntryDetail({});
        setEntryDetailResetKey(current => current + 1);
    }

    function applyRawPurchaseReferenceDetail(detail) {
        setEntryDetail(detail || {});
        setEntryDetailResetKey(current => current + 1);
    }

    function applyRawSupplyReferenceDetail(detail) {
        setEntryDetail(detail || {});
        setEntryDetailResetKey(current => current + 1);
    }


    useEffect(() => {
        return () => {
            ++rawPurchaseReferenceRequestRef.current;
            ++rawSupplyReferenceRequestRef.current;
            ++locationSaveRequestRef.current;
        };
    }, []);

    useEffect(() => {
        if (!layoutReady) return;
        layoutReadyRef.current = true;
        layoutReadySearchRef.current = search;
        const pendingShow = pendingShowRef.current;
        if (pendingShow === null) return;
        pendingShowRef.current = null;
        if (pendingShow.search !== search) return;
        executeShow(pendingShow.data, pendingShow.pushcode, pendingShow.option);
    }, [layoutReady]);

    useEffect(() => {
        if (formstatus !== "COPY FORM") return;
        entrydataRef.current = {
            ...(entrydataRef.current || {}),
            ZSK_DENNO: "",
            ZSK_MOTODENNO: "",
            ZSK_MAEDENNO: "",
            ZSK_AKAKUROKBN: "1",
            ZSK_TEISEIFLG: "0",
            ZSK_TEISEIKBN: "1",
            ZSK_KEIJYODATE: "",
            ZSK_GENKA_KEIJYODATE: "",
            ZSK_REQFLG: "",
            ZSK_REQDATETIME: "",
            ZSK_SYNFLG1: "",
            ZSK_SYNFLG2: "",
            ZSK_SYNFLG3: "",
            ZSK_SYNDATETIME1: "",
            ZSK_SYNDATETIME2: "",
            ZSK_SYNDATETIME3: "",
            ZSK_SYNTANTOCD1: "",
            ZSK_SYNTANTOCD2: "",
            ZSK_SYNTANTOCD3: "",
            ZSK_KIKANCP_FLG: "",
            ZSK_KIKANCP_DATETIME: "",
            ZSK_DENPRT_DATETIME: "",
            ZSK_DOWNLOADDATETIME: "",
            ZSK_DOWNLOADTANTO: "",
            ZSK_DELDATETIME: "",
            ZSK_INVALID: 0,
            ZSK_INPCID: "",
            ZSK_CREATEAC: "",
            ZSK_CREATEDATE: "",
            ZSK_UPPCID: "",
            ZSK_UPDATEAC: "",
            ZSK_UPDATE: "",
        };
        fnc.current.entryrerender();
        fnc.current.modify(false);
    }, [formstatus]);

    useEffect(() => {
        if (formstatus !== "ENTRY FORM") {
            dispatch(entryformlock(false));
        }
    }, [dispatch, formstatus]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        layoutReadyRef.current = false;
        setLayoutReadySearch(null);
        const requestId = ++layoutRequestRef.current;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    if (requestId !== layoutRequestRef.current) return;
                    setPanels(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts,
                        prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setColumnInfo(data.colinfo);
                    setColumns(data.columns);
                    fnc.current.initMaster(data.master);

                    let index = 0;
                    const gridList = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridList.push({ id: panel.id, type: panel.type, index: index });
                        index++;
                        const total = data.colinfo.find(e => e.logpid === "T" + panel.id);
                        if (!isEmpty(total)) {
                            gridList.push({ id: "T" + panel.id, type: total.type, index: index });
                            index++;
                        }
                    });
                    dispatch(setgridlist(gridList));

                    setLayoutReadySearch(search);
                    fnc.current.wait(false);
               }
            });
    }, [search]);
    const layoutLock = (menuinfo?.ctrls || []).indexOf("LOCK2") !== -1;
    const showEntryToolbar = formstatus === 'NEW FORM'
        || formstatus === 'ENTRY FORM'
        || formstatus === 'COPY FORM';

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={masterRef}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
                entryform={true}
                entrycallback={entryAction}
                show={show}
                suppressaction={suppressaction}
           >
                {layoutReady ? <RawSupplyInEntry
                    ref={entryRef}
                    key={entryResetKey}
                    panels={panels}
                    setPanels={setPanels}
                    columninfo={columnInfo}
                    columns={columns}
                    setColumns={setColumns}
                    entrydataRef={entrydataRef}
                    detail={entryDetail}
                    fnc={fnc}
                    formid={formid}
                    controller={controller}
                    subkey={subkey}
                    materialType={materialType}
                    entryDetailResetKey={entryDetailResetKey}
                    resetReferenceSourceDetail={resetReferenceSourceDetail}
                    applyRawPurchaseReferenceDetail={applyRawPurchaseReferenceDetail}
                    applyRawSupplyReferenceDetail={applyRawSupplyReferenceDetail}
                    rawPurchaseReferenceRequestRef={rawPurchaseReferenceRequestRef}
                    rawSupplyReferenceRequestRef={rawSupplyReferenceRequestRef}
                    rawPurchaseReferenceMaterialTypeRef={rawPurchaseReferenceMaterialTypeRef}
                /> : null}
            </MasterBase>
            {showEntryToolbar ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton
                            size="small"
                            onClick={() => fnc.current.entrysettingopen()}
                            title="レイアウト設定"
                        >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: windowDimensions.width - 280 }}
                        >
                            <SortablePanelSelector
                                axis="x"
                                items={toolbarPanels()}
                                layoutLock={layoutLock}
                                onSortEnd={sortToolbarPanels}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
        </div>
    );
};


